import {useMemo} from 'react';
import {GUEST_FORM_NAMES, isVisibleFormField} from '@chekin/core';
import {useSchema} from 'context/guest';
import {AGREEMENT_CLAUSE_FIELDS, IV_FIELDS, SIGNATURE_FIELDS} from 'utils/guestForm';
import {useGuestGroup} from './useGuestGroup';
import {useAutofilledFieldsStore} from './useAutofilledFields';

const GUEST_FORM_FIELD_NAMES = new Set<string>(Object.values(GUEST_FORM_NAMES));

const NON_DETAIL_FIELDS = new Set<string>([
  ...IV_FIELDS,
  ...SIGNATURE_FIELDS,
  ...AGREEMENT_CLAUSE_FIELDS,
]);

const isGuestDetailField = (name: string) =>
  GUEST_FORM_FIELD_NAMES.has(name) && !NON_DETAIL_FIELDS.has(name);

export type ScanSummary = {
  hasScan: boolean;
  filled: number;
  total: number;
  missing: number;
};

export function useScanSummary(): ScanSummary {
  const {formFields} = useSchema();
  const {isLeaderGuest} = useGuestGroup();
  const scannedFields = useAutofilledFieldsStore(state => state.fields);

  return useMemo(() => {
    const asked = Object.entries(formFields ?? {})
      .filter(
        ([name, field]) =>
          isGuestDetailField(name) && isVisibleFormField(field, isLeaderGuest),
      )
      .map(([name]) => name);

    const filled = asked.filter(name => scannedFields.includes(name)).length;

    return {
      hasScan: scannedFields.length > 0 && asked.length > 0,
      filled,
      total: asked.length,
      missing: asked.length - filled,
    };
  }, [formFields, isLeaderGuest, scannedFields]);
}
